var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { router } from '@inertiajs/react';
import { useForm, usePage } from '@inertiajs/react';
import classNames from 'classnames';
import { useRef, useState } from 'react';
import { useRoute } from 'ziggy-js';
import JetActionMessage from '@/Jetstream/ActionMessage';
import JetButton from '@/Jetstream/Button';
import JetFormSection from '@/Jetstream/FormSection';
import JetInput from '@/Jetstream/Input';
import JetInputError from '@/Jetstream/InputError';
import JetLabel from '@/Jetstream/Label';
import JetSecondaryButton from '@/Jetstream/SecondaryButton';
import { Ziggy } from "@/ziggy";
export default function UpdateProfileInformationForm(_a) {
    var user = _a.user;
    var form = useForm({
        _method: 'PUT',
        name: user.name,
        email: user.email,
        photo: null,
        marketing_optin: user.marketing_optin,
    });
    var route = useRoute(Ziggy);
    var _b = useState(null), photoPreview = _b[0], setPhotoPreview = _b[1];
    var photoRef = useRef(null);
    var page = usePage();
    function updateProfileInformation() {
        // if (photoRef.current) {
        //   form.transform(data => ({
        //     ...data,
        //     photo: photoRef.current?.files?.[0] || null,
        //   }));
        // }
        form.post(route('user-profile-information.update'), {
            errorBag: 'updateProfileInformation',
            preserveScroll: true,
            onSuccess: function () { return clearPhotoFileInput(); },
        });
    }
    function selectNewPhoto() {
        var _a;
        (_a = photoRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }
    function updatePhotoPreview() {
        var _a, _b, _c, _d;
        var photo = (_b = (_a = photoRef.current) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b[0];
        if (!photo)
            return;
        var reader = new FileReader();
        reader.onload = function (e) {
            var _a;
            setPhotoPreview((_a = e.target) === null || _a === void 0 ? void 0 : _a.result);
        };
        reader.readAsDataURL(photo);
        form.setData('photo', ((_d = (_c = photoRef.current) === null || _c === void 0 ? void 0 : _c.files) === null || _d === void 0 ? void 0 : _d[0]) || null);
    }
    function deletePhoto() {
        router.delete(route('current-user-photo.destroy'), {
            preserveScroll: true,
            onSuccess: function () {
                setPhotoPreview(null);
                clearPhotoFileInput();
            },
        });
    }
    function clearPhotoFileInput() {
        var _a;
        if ((_a = photoRef.current) === null || _a === void 0 ? void 0 : _a.value) {
            photoRef.current.value = '';
        }
    }
    return (_jsxs(JetFormSection, __assign({ onSubmit: updateProfileInformation, title: 'Profile information', description: "Update your account's profile information and email address.", renderActions: function () { return (_jsxs(_Fragment, { children: [_jsx(JetActionMessage, __assign({ on: form.recentlySuccessful, className: "mr-3" }, { children: "Saved." })), _jsx(JetButton, __assign({ className: classNames({ 'opacity-25': form.processing }), disabled: form.processing }, { children: "Save" }))] })); } }, { children: [page.props.jetstream.managesProfilePhotos ? (_jsxs("div", __assign({ className: "col-span-6 sm:col-span-4" }, { children: [_jsx("input", { type: "file", className: "hidden", ref: photoRef, onChange: updatePhotoPreview }), _jsx(JetLabel, { htmlFor: "photo", value: "Photo" }), photoPreview ? (
                    // <!-- New Profile Photo Preview -->
                    _jsx("div", __assign({ className: "mt-2" }, { children: _jsx("span", { className: "block rounded-full w-20 h-20", style: {
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center center',
                                backgroundImage: "url('".concat(photoPreview, "')"),
                            } }) }))) : (
                    // <!-- Current Profile Photo -->
                    _jsx("div", __assign({ className: "mt-2" }, { children: _jsx("img", { src: user.profile_photo_url, alt: user.name, className: "rounded-full h-20 w-20 object-cover" }) }))), _jsx(JetSecondaryButton, __assign({ className: "mt-2 mr-2", type: "button", onClick: selectNewPhoto }, { children: "Select a new photo" })), user.profile_photo_path ? (_jsx(JetSecondaryButton, __assign({ type: "button", className: "mt-2", onClick: deletePhoto }, { children: "Remove photo" }))) : null, _jsx(JetInputError, { message: form.errors.photo, className: "mt-2" })] }))) : null, _jsxs("div", __assign({ className: "col-span-6 sm:col-span-4" }, { children: [_jsx(JetLabel, { htmlFor: "name", value: "Name" }), _jsx(JetInput, { id: "name", type: "text", className: "mt-1 block w-full", value: form.data.name, onChange: function (e) { return form.setData('name', e.currentTarget.value); }, autoComplete: "name" }), _jsx(JetInputError, { message: form.errors.name, className: "mt-2" })] })), _jsxs("div", __assign({ className: "col-span-6 sm:col-span-4" }, { children: [_jsx(JetLabel, { htmlFor: "email", value: "Email" }), _jsx(JetInput, { id: "email", type: "email", className: "mt-1 block w-full ".concat(page.props.user.azure_id ? "bg-gray-100 text-gray-700" : ""), value: form.data.email, onChange: function (e) { return form.setData('email', e.currentTarget.value); }, "data-lpignore": "true", disabled: page.props.user.azure_id }), _jsx(JetInputError, { message: form.errors.email, className: "mt-2" })] })), _jsxs("div", __assign({ className: "col-span-6 sm:col-span-4 flex" }, { children: [_jsx("div", __assign({ className: "flex items-center h-5" }, { children: _jsx("input", { id: "marketing_optin", name: "marketing_optin", type: "checkbox", value: 1, onChange: function (e) {
                                return form.setData('marketing_optin', form.data.marketing_optin ? 0 : 1);
                            }, checked: !!form.data.marketing_optin, className: "focus:ring-sky-500 h-4 w-4 text-sky-600 border-gray-300 rounded" }) })), _jsx("div", __assign({ className: "ml-3 text-sm" }, { children: _jsx("label", __assign({ htmlFor: "marketing_optin", className: "text-gray-600" }, { children: "I want to receive news, feature updates, discounts, and offers from OVForm." })) }))] }))] })));
}
